import useDevice from 'hooks/DesktopDevice.hook';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store/store';
import Button from 'styles/button/Button';
import Stack from 'styles/stack/Stack';
import Typography from 'styles/typography/Typograpy';
import { useTranslation } from 'utils/translations';

type ContainerFooter = {
	ml?: string;
};

export const FooterDesktop: React.FC<ContainerFooter> = props => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const year = new Date().getFullYear();
	const { isDesktop } = useDevice();
	const navigate = useNavigate();
	const { links } = useSelector((store: RootState) => store.footer);

	const openInNewTab = (url: string) => {
		if (url[0] === '/') {
			navigate(url);
			return;
		}
		window.open(url, '_blank', 'noopener,noreferrer');
	};

	return (
		<Stack
			sx={{ borderTop: 1, ml: !!props.ml ? props.ml : 0 }}
			direction={'row'}
			height={!!isDesktop ? '70px' : '60px'}
			alignItems={'center'}
		>
			<Stack flexGrow={1}>
				<Typography variant="caption">{`© ${year} ${tClientLabels(
					'sharedLayout.footerRightReserved',
				)}`}</Typography>
			</Stack>
			<Stack flexGrow={0} direction={'row'} gap={!!isDesktop ? 4.75 : 2.5}>
				{links.map((l, index: number) => {
					return (
						<Button variant="link" onClick={() => openInNewTab(l.url)} key={index}>
							<Typography variant="caption">{l.label}</Typography>
						</Button>
					);
				})}
			</Stack>
		</Stack>
	);
};
